import { Button } from '@/components/ui/button'

interface TFLSidebarDeleteFooterProps {
  selectedCount: number
  onCancel: () => void
  onConfirm: () => void
}

export const TFLSidebarDeleteFooter = ({
  selectedCount,
  onCancel,
  onConfirm,
}: TFLSidebarDeleteFooterProps) => {
  return (
    <div className="p-4 flex justify-between border-t border-x-0 border-b-0 border-solid border-secondary">
      <Button
        variant="outlined"
        className="text-secondary-700"
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        variant="default"
        className="text-white bg-error-solid border-transparent hover:bg-error-solid"
        disabled={selectedCount === 0}
        onClick={onConfirm}
      >
        Delete
      </Button>
    </div>
  )
}
